import React from 'react'
import { Downgraded } from '@hookstate/core'
import { useLang } from '~/hooks/useLang'
import { Grid, Typography } from '@mui/material'
import ColumnChartHorizontal from '~/components/ColumnChartMui/HorizontalChart'
import useManagementQualifiersWeaponState from '~/features/Management/stores/ManagementQualifiersWeaponState'
import PieChartMui from '~/components/PieChartMui'
import { addTotals, calculateBarChartTotal } from '~/utils/format'

interface ChartsWeaponProps {
  readonly expandFilterSearch: boolean
}

export default function ChartsWeapon({
  expandFilterSearch,
}: ChartsWeaponProps) {
  const { translate } = useLang()
  const { occurrencesAssociatedWeapon } = useManagementQualifiersWeaponState()


  return (
    <Grid
      container
      xs={12}
      sx={{
        display: 'flex',
        paddingX: 3,
        paddingTop: 3,
        justifyContent: 'space-between',
      }}
    >
      <Grid item xs={12} hidden={!expandFilterSearch} paddingBottom={1}>
        <Typography sx={{ fontWeight: 'bold', fontSize: 16 }}>
          {translate('Registered weapon')}
        </Typography>
      </Grid>

      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <PieChartMui
          data={occurrencesAssociatedWeapon()
            .occurrencesAssociatedWeaponByType.attach(Downgraded)
            .get()}
          title={'WeaponType:name'}
          subtitle={`Total de armas: ${addTotals(
            occurrencesAssociatedWeapon()
              .occurrencesAssociatedWeaponByType.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'statusMinus'}
          showPercent
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedWeapon()
            .occurrencesAssociatedWeaponByKindType.attach(Downgraded)
            .get()}
          title={'WeaponType:kind'}
          subtitle={`Total de armas: ${calculateBarChartTotal(
            occurrencesAssociatedWeapon()
              .occurrencesAssociatedWeaponByKindType.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'typeMinus'}
          colorBar="primary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedWeapon()
            .occurrencesAssociatedWeaponByOccurrenceType.attach(Downgraded)
            .get()}
          title={`${translate('WeaponModel:name')}`}
          subtitle={`Total de armas: ${calculateBarChartTotal(
            occurrencesAssociatedWeapon()
              .occurrencesAssociatedWeaponByOccurrenceType.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'typeMinus'}
          colorBar="secondary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedWeapon()
            .occurrencesAssociatedWeaponByCircunstance.attach(Downgraded)
            .get()}
          title={`${translate('Circunstance of the weapon')}`}
          subtitle={`Total de armas: ${calculateBarChartTotal(
            occurrencesAssociatedWeapon()
              .occurrencesAssociatedWeaponByCircunstance.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'situations'}
          colorBar="tertiary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedWeapon()
            .occurrencesAssociatedWeaponByDestination.attach(Downgraded)
            .get()}
          title={`${translate('Final destination of the weapon')}`}
          subtitle={`Total de armas: ${calculateBarChartTotal(
            occurrencesAssociatedWeapon()
              .occurrencesAssociatedWeaponByDestination.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'finals destinations'}
          colorBar="primary"
        />
      </Grid>
    </Grid>
  )
}
